import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'
import page404 from '../views/404.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/wykonawca/:uuid',
    name: 'Contractor',
    component: () => import(/* webpackChunkName: "contractor" */ '../views/Contractor.vue'),
    props: true
  },
  {
    path: '/wystaw-opinie/:uuid',
    name: 'CreateReview',
    component: () => import(/* webpackChunkName: "createReview" */ '../views/CreateReview.vue'),
    props: true
  },
  {
    path: '/youtube',
    name: 'Youtube',
    component: () => import(/* webpackChunkName: "YouTube" */ '../views/YouTube.vue'),
    props: true
  },
  {
    path: '/zostan-super-wykonawca',
    name: 'SuperWykonawca',
    component: () => import(/* webpackChunkName: "zostanSuperWykonawca" */ '../views/SuperWykonawca.vue'),
    props: true
  },
  {
    path: '/program-lojalnosciowy',
    name: 'ProgramLojanosciowy',
    component: () => import(/* webpackChunkName: "programLojanosciowy" */ '../views/ProgramLojalnosciowy.vue'),
    props: true
  },
  {
    path: '/aplikacja',
    name: 'Aplikacja',
    component: () => import(/* webpackChunkName: "aplikacja" */ '../views/Aplikacja.vue'),
    props: true
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: page404,
  },
  {
    path: '/404',
    name: 'page404',
    component: page404,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.NODE_ENV === 'production' ?
      process.env.VUE_APP_RELATIVE_URL :
      process.env.BASE_URL
  ),
  routes
})

export default router
